import React, { createContext } from 'react'

const SdfContext = createContext()

export default SdfContext
